import { useQuery } from '@tanstack/react-query';
import { api, ok } from '../../lib/api.js';
import { ASSISTANCE_KEY } from './assistance.js';

/** O catálogo da base: os grupos e os serviços (02/11/2026). */
export const CATALOG_KEY = [...ASSISTANCE_KEY, 'servicos'] as const;

/**
 * Os grupos e os serviços da praça. Quem aciona lê daqui o serviço de cada
 * tipo; o cadastro do prestador lê para montar a tabela; Plataforma ›
 * Assistência 24h › Serviços muda. O grupo é código — a lista dele não muda —,
 * e o serviço quase não muda, por isso a consulta vive cinco minutos.
 */
export function useAssistanceCatalog(enabled = true) {
  return useQuery({
    queryKey: CATALOG_KEY,
    enabled,
    staleTime: 5 * 60_000,
    queryFn: async () =>
      ok(
        await api.assistance.listServices(),
        200,
        'Não foi possível carregar os serviços da assistência.',
      ),
  });
}
